/**
 * 웹 버전 관리를 위한 버전 식별자
 * package.json 의 build 스크립트가 빌드타임에 아래 두 값을 번들에 env 로 주입
 * build/version.json 과 동일 시간에 동일 소스로 기록되므로, 번들의 값과 version.json의 값이 다른 경우 번들이 stale 상태라고 판단할 수 있음
 */
export const APP_VERSION: string = process.env.REACT_APP_VERSION || "0.0.0-dev";

/**
 * 빌드 식별자: ISO-8601 UTC "YYYY-MM-DDTHH:mm:ssZ"(예 "2026-06-17T07:30:16Z", Z=UTC)
 * 미주입(dev 서버 등)이면 hasUpdate에서 version(semver) 비교로 폴백
 */
export const BUILD_TIMESTAMP: string = process.env.REACT_APP_BUILD_TIMESTAMP || "";

/**
 * ctrl-room 은 nginx 루트('/')에서 서빙되고 PUBLIC_URL 미설정이므로 "/version.json"
 */
const ASSET_BASE = process.env.PUBLIC_URL ?? "";
export const VERSION_JSON_URL = `${ASSET_BASE}/version.json`;
